import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var base = "new-equity/";
var revamp = config.revamp;
var commonConfigURL = {
    sidebar: config.jmw + revamp + config.jmw_content + base + "scrip",
    web_config_access_reports: config.oldWebUrl + config.web_config_access_reports,
    msloginVerify: config.jmw + config.jmw_market_env + "app-ewin/login/token",
    portalLoginUrl: config.jmw + "app-ewin/login/otp",
    portalValidateOtp: config.jmw + "app-ewin/login/validate-otp",
    portalResendOtp: config.jmw + "app-ewin/login/resend-otp",
};
export default commonConfigURL;
